module.exports = __webpack_public_path__ + "img/goodsC2.a2a78686.png";